import {createSlice} from "@reduxjs/toolkit";

const initialState: {
    globalLanguage: string
} = {
    globalLanguage: "pl-PL",
};

const languageSlice = createSlice({
    name: "languageSlice",
    initialState,
    reducers: {
        setGlobalLanguage: (state) => {
            state.globalLanguage = "pl-PL";
        }
    }
});

export const {setGlobalLanguage} = languageSlice.actions;

export const getGlobalLanguage = (state: any) => state.language.globalLanguage as "pl-PL" | "uk-UA";

export default languageSlice.reducer;
